export const messages = {
  en: {
    accountWithdrawalApplyListManage: {
      accountWithdrawalRecords: 'Account Withdrawal Records',
      withdrawalAmount: 'Withdrawal Amount',
      applicantName: 'Applicant Name',
      applicantPhone: 'Applicant Phone',
      applicationDescription: 'Application Description',
      status: 'Status',
      queryConditions: 'Query Conditions',
      query: 'Query',
      enterApplicantName: 'Enter applicant name',
      enterApplicantPhone: 'Enter applicant phone'
    }
  },
  zh: {
    accountWithdrawalApplyListManage: {
      accountWithdrawalRecords: '账户提现记录',
      withdrawalAmount: '提现金额',
      applicantName: '申请人名称',
      applicantPhone: '申请人电话',
      applicationDescription: '申请说明',
      status: '状态',
      queryConditions: '查询条件',
      query: '查询',
      enterApplicantName: '请输入申请人名称',
      enterApplicantPhone: '请输入申请人电话'
    }
  }
}